/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReportRequest
 */
export interface CreateReportRequest {
    /**
     * The patient ID to add the report to
     * @type {string}
     * @memberof CreateReportRequest
     */
    patient_id: string;
    /**
     * The title of the report (e.g., "Executive Menopause Health Report")
     * @type {string}
     * @memberof CreateReportRequest
     */
    title: string;
    /**
     * The markdown content of the report
     * @type {string}
     * @memberof CreateReportRequest
     */
    content: string;
    /**
     * Optional appointment ID to link the report to
     * @type {string}
     * @memberof CreateReportRequest
     */
    appointment_id?: string;
}

/**
 * Check if a given object implements the CreateReportRequest interface.
 */
export function instanceOfCreateReportRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "patient_id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "content" in value;

    return isInstance;
}

export function CreateReportRequestFromJSON(json: any): CreateReportRequest {
    return CreateReportRequestFromJSONTyped(json, false);
}

export function CreateReportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReportRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'],
        'title': json['title'],
        'content': json['content'],
        'appointment_id': !exists(json, 'appointment_id') ? undefined : json['appointment_id'],
    };
}

export function CreateReportRequestToJSON(value?: CreateReportRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient_id': value.patient_id,
        'title': value.title,
        'content': value.content,
        'appointment_id': value.appointment_id,
    };
}

